import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const messages = {
  en: {
    title: "E-SoR 易清單",
    login: {
      title: "Log into your account",
      username: "Email",
      otp: "One-Time Password",
      get_otp: "Get OTP",
      otp_resend_countdown: "Resend in {second}s",
      password: "Password",
      login_with_saml: "Login with ADFS",
      login: "Login",
      sso: "Connect with ASD Account",

      forget_password: "FORGOT PASSWORD / RESET PASSWORD",

      signup_1: "Don't have an account? ",
      signup_2: "Sign up",
    },
    password_expired: {
      title: "Password Expired",
      old_password: "Current Password",
      new_password: "New Password",
      confirm_password: "Confirm New Password",

      success_msg:
        "Password Reset Successfully. Please login with the new password",
    },
    reset_password: {
      title: "Reset Password",
      username: "Email",
      otp: "One-Time Password",
      get_otp: "Get OTP",
      otp_resend_countdown: "Resend in {second}s",
      new_password: "New Password",
      confirm_password: "Confirm New Password",

      success_msg:
        "Password Reset Successfully. Please login with the new password",
    },
    signup: {
      title: "Create an Account",
      password: "Password",
      re_enter_password: "Re-enter Password",
      signup: "Sign Up",

      password_contain_eight_characters:
        "Password contains more than 8 characters",
      password_contain_uppercase_letters:
        "Password contains at least one uppercase letter",
      password_contain_lowercase_letters:
        "Password contains at least one lowercase letter",
      password_contain_numbers: "Password contains at least one number digit",
      password_contain_special_characters:
        "Password contains at least one special characters (excluding space character)",
      password_mismatch: "Password inputs do not match",
    },
    app_drawer: {
      whitelist: "ADFS Whitelist",
      users: "User Management",
      sor: "Schedule of Rates (SoR)",
      contract: "Contract Management",
      nsr: "NSR Items for Dimbook Adjustment",
      settings: "Setting",
      sections: "Sections",
      public_dim_book: "General Dimbook",
      template_verification: "Template Verification",
      rbu_datasets: "Reference Database",
      rbu: "RBU",
    },
    landing: {
      disclaimer:
        "<h1>Disclaimer</h1>\n" +
        "    <ol>\n" +
        "      <li>The Schedule of Rates shown in this System is solely compiled for Term Contracts for which the Architectural\n" +
        "        Services Department is responsible. The Schedule rates may not necessarily reflect the market values of\n" +
        "        materials / products / works as included in the Schedule of Rates for Term Contracts for Building Works (SoR).\n" +
        "        Before making use of this System or SoR for any costing preparation, the users shall also read together with\n" +
        "        the Section 00 - General Regulations and Special Conditions in the respective sections under the SoR\n" +
        "        carefully.\n" +
        "      </li><br>\n" +
        "      <li>There are no representations, either expressed or implied, as to the suitability of this System or SoR for\n" +
        "        purposes other than that stated above, and no liability and responsibility for any special, indirect or\n" +
        "        consequential loss or damages whatsoever arising out of or in connection with the use of this System or SoR or\n" +
        "        reliance placed on it shall be bored and accepted.\n" +
        "      </li><br>\n" +
        "      <li>Users who choose to adopt this System or SoR for other purposes are responsible for making their own\n" +
        "        assessments and judgment of all information contained here, and they shall acknowledge and shall deem to have\n" +
        "        acknowledged any risks and consequences resulted from such use.\n" +
        "      </li>\n" +
        "    </ol>",
    },
    whitelist: {
      username: "Username",

      import_title: "Import ADFS Whitelist",
      import_step_1: "Upload",
      import_step_2: "Preview",
      import_step_3: "Complete",
      download_template: "Download Excel Template",
      upload_template: "Upload Excel",
      import_errors: "Import Error(s)",
      import_added: "Added",
      import_removed: "Removed",
      import_success_msg: "ADFS Whitelist Successfully Imported",

      add_title: "Add ADFS Whitelist",

      delete: "Remove",
      delete_confirm_msg:
        "Remove Username from whitelist? Related Accounts will be disabled.",
    },
    user: {
      is_external: "External User",
      external: "External User",
      internal: "Internal User",

      username_or_email: "Username / Email Address",
      username: "Username",
      email: "Email Address",
      name: "Name",
      company: "Company / Branch",
      post: "Post",
      phone: "Telephone",
      contracts: "Contracts",
      disabled: "Status",
      disabled_true: "Inactive",
      disabled_false: "Active",
      disabled_updated: "User Status Updated",
      last_login: "Last Login",
      never_login: "Never Login",
      is_idle: "Last Login > 180 days",

      create_title: "New User",

      type: "User Type",
      permissions: "Permissions",
      super_admin: "Super Admin",
      is_admin: "System Admin",
      manage_sor: "SoR Admin",
      input_sor: "SoR Input",
      create_contract: "Create Contracts",
      manage_nsr: "Manage NSR Items (All)",
      manage_nsr_ind: "Manage NSR Items (Individual)",

      reset_password: "Reset Password",
    },
    edition: {
      title: "Schedule of Rates (SoR) Editions",
      detail_title: "Schedule of Rates (SoR) Edition: ",

      id: "Year",
      latest_version: "Latest Version",
    },
    sor: {
      edition: "Year",
      name: "Title",
      type: "Type",
      not_available_for_sale: "Not Available For Sale",
      finalised_at: "Finalised At",
      action_input_finalised_at: "ACTION Input Finalised At",

      finalised: "Finalised",
      previous_version: "Previous Version",
      updated_at: "Last Update",

      create_title: "Create New SoR Edition",

      finalise: "Finalise",
      finalise_confirm_msg:
        "Finalise SoR? Sections and PDFs will no longer be editable.",
      finalise_action_input_confirm_msg:
        "Finalise ACTION Input? ACTION Input will no longer be editable",
      un_finalise: "Un-Finalise",
      un_finalise_confirm_msg: "Un-Finalise SoR?",
      download_pdf: "Download PDF",
      download_reference_table: "Download Reference Table",

      action_input: "ACTION Input",
      download_action_input: "Download",
      import_action_input: "Upload ACTION Input",
      action_input_not_available:
        "ACTION Input will be available once all the volumes' ACTION inputs are finalised",
      action_input_being_generated:
        "The initial version of ACTION Input is being generated. Please wait.",
      download_action_input_dbf: "Download DBF",
      export_bms_excel: "BMS",
    },
    corrigendum: {
      download_template: "Download Template",
      import_title: "Upload Corrigendum Excel",
      excel: "Corrigendum Excel",

      finalise_confirm_msg:
        "Finalise Corrigendum Excel? Excel will no longer be editable.",
      finalise_action_input_confirm_msg:
        "Finalise Corrigendum ACTION Input? ACTION Input will no longer be editable",
      un_finalise: "Un-Finalise",
      un_finalise_confirm_msg: "Un-Finalise Corrigendum Excel?",

      action_input: "Corrigendum ACTION Input",
      action_input_not_available:
        "Corrigendum ACTION Input could be uploaded once the Corrigendum Excel is finalised",

      finalised_action_input: "Combined ACTION Input",
      finalised_action_input_not_available:
        "Combined ACTION Input will be available once the Corrigendum ACTION Input is finalised",
    },
    volume: {
      title: "Volume",
      create_title: "Create Volume",

      order_no: "Volume No.",
      name: "Title",
      finalised_at: "Finalised At",
      action_input_finalised_at: "ACTION Input Finalised At",
      cover_pdf: "Section 00",

      preview_all: "Preview All Sections",
      download_all_excels: "Download All Excels",
    },
    action_input: {
      created_at: "Last Update",
      filename: "Filename",
      finalised_at: "Finalised At",
    },
    section: {
      title: "Sections",

      name: "Section Name",
      order_no: "Section No.",
      updated_at: "Last Updated At",

      import_title: "Upload Section Excel",
      section_excel: "Section Excel",
      special_conditions: "Special Conditions PDF",

      edit_title: "Edit Section",

      preview: "Preview PDF",
    },
    item: {
      item_no: "Item No.",
      descriptions: "Item Descriptions",
      unit: "Unit",
      rate: "Rate",
    },
    contract: {
      create_title: "New Contract",

      id: "Contract No.",
      name: "Contract Name",
      finalised_at: "Status",
      details: "Details",
      created_by: "Created By",

      not_finalised: "In Progress",
      finalised: "Finalised",
      finalise: "Finalise",

      sor: "SoR Edition",

      a_sor: "ASoR",
      a_sor_not_available:
        "ASoR could be uploaded once the Contract SoR Edition is finalised",
      a_sor_finalise_confirm_msg: "Finalise ASoR?",
      a_sor_un_finalise_confirm_msg: "Un-finalise ASoR?",

      a_sor_action_input: "ASoR ACTION Input",
      a_sor_action_input_not_available:
        "ASoR ACTION Input could be uploaded once the ASoR is finalised",
      a_sor_finalise_action_input_confirm_msg:
        "Finalise ASoR ACTION Input? ACTION Input will no longer be editable",

      action_input: "Contract ACTION Input",
      action_input_not_available:
        "Contract ACTION Input will be available once the ASoR ACTION Input is finalised",

      contract_percentage: "Contract Percentages",
      contract_percentage_not_available:
        "Contract Percentage could be uploaded once the ASoR is finalised",
      contract_percentage_import_title: "Upload Contract Percentage",
      contract_percentage_year: "Contract Year",
      contract_percentage_excel: "Contract Percentage Excel",
    },
    a_sor: {
      create_title: "Create Contract A-SoR",
      import_title: "Import Contract A-SoR Excel",

      name: "A-SoR Title",
      excel: "A-SoR Excel",
      special_conditions_pdf: "Special Conditions PDF",

      finalise_confirm_msg:
        "Finalise A-SoR Excel? Excel will no longer be editable.",
      un_finalise_confirm_msg:
        "Un-Finalise A-SoR Excel? Generated ACTION Input will be deleted.",

      action_input: "A-SoR ACTION Input",
      finalised_action_input: "Combined ACTION Input",
      action_input_not_available:
        "A-SoR ACTION Input could be uploaded once the A-SoR Excel is finalised",
      regen_action_input_confirm_msg: "Regenerate ACTION Input Excel?",
      finalised_action_input_not_available:
        "Combined ACTION Input will be available once the A-SoR ACTION Input is finalised",
    },
    contract_year: {
      updated_at: "Last Update",
      year: "Contract Year",
      percentage_excel: "Contract Percentage Excel",
      finalised_at: "Status",

      delete_confirm_msg: "Delete Contract Year?",
      finalise_confirm_msg:
        "Finalise Contract Year? Contract Percentages will no longer be editable.",
    },
    contract_admin: {
      title: "Contract Admin",
      add_title: "Add Contract Admin",
      transfer_title: "Transfer Contract Admin",

      name: "Name",
      post: "Post",
      company: "Company",
      managed_work_orders_count: "W.O. Count",
      status: "Status",

      delete_confirm_msg: "Delete Contract Admin?",
      approve_confirm_msg: "Approve Contract Admin Application?",
      decline_confirm_msg: "Decline Contract Admin Application?",
      transfer_confirm_msg: "Transfer Contract Admin?",
    },
    contract_user: {
      title: "Contract User",
      add_title: "Add Contract User",

      name: "Name",
      post: "Post",
      company: "Company",
      managed_work_orders_count: "W.O. Count",
      status: "Status",

      delete_confirm_msg: "Delete Contract User?",
      approve_confirm_msg: "Approve Contract User Application?",
      decline_confirm_msg: "Decline Contract User Application?",
    },
    work_order: {
      create_title: "Create Works Order",
      edit_title: "Edit Works Order",
      transfer_title: "Transfer Works Order",

      contract_id: "Contract No.",
      contract_year: "Contract Year",
      work_order_no: "W.O. No.",
      name: "W.O. Name",
      admin: "W.O. Admin",
      nature: "Type",
      is_estimate: "Estimate",

      csv: "TH_DB_ADJ_ITEM.csv From ACTION",

      transfer_confirm_msg: "Transfer Works Order(s)?",
    },
    work_order_nature: {
      P_ORDER: "P ORDER",
      B_ORDER: "B ORDER",
      E_ORDER: "E ORDER",
    },

    user_type: {
      SUPER_ADMIN: "Super Admin",
      ADMIN: "System Admin",
      USER: "User",
    },
    permissions: {
      esor: {
        manage_sor: "SoR Admin",
        input_sor: "SoR Input",
        create_contract: "Create Contracts",
        manage_contract: "Manage Contract",
        manage_nsr: "Manage NSR Items (All)",
        manage_nsr_ind: "Manage NSR Items (Individual)",
      },
      rbu: {
        manage_edition: "Manage RBU Edition",
        manage_dataset: "Manage RBU Dataset",
        template_verification: "Template Verification",
      },
    },

    file_input: {
      descriptions: "Click or Drop file here",
      dragover_descriptions: "Release to Upload",
      size_limit: "Maximum file size 2MB",
    },
    abbreviation: {
      title: "ACTION Input Abbreviations",

      phrase: "Phrase",
      abbreviation: "Abbreviation",

      import_title: "Import Abbreviations",
      export_title: "Export",
      import_excel: "Abbreviation Excel",
    },
    unicode_escape: {
      title: "Unicode Escapes",

      replaced: "Replaced",
      replacing: "Replacing",

      import_title: "Import Unicode Escapes",
      export_title: "Export",
      import_excel: "Unicode Escapes Excel",
    },
    nsr_item: {
      title: "NSR Items for Dimbook Adjustment",
      create_title: "Create NSR Item",
      edit_title: "Edit NSR Item",

      item_no: "Item No.",
      contract_no: "Contract No.",
      contract_year: "Contract Year",
      work_order_no: "Works Order No.",
      action_description: "Description",
      value: "Rate",
      unit: "Unit",
      unit_id: "Unit ID",
      trade_code: "Trade Code",
      request_date: "Request Date",
      approval_date: "Approval Date",
      contractor_claim: "Contractors Claim",

      delete_confirm_msg: "Delete NSR Item?",
    },

    dataset: {
      create_title: "Create Dataset",

      types: "Types",
      title: "Title",
      last_updated_at: "Last Updated At",
      latest_data: "Latest Data",
      alias: "Alias",
    },
    dataset_issue: {
      period: "Period",
      imported_from_api: "Manually Imported",
    },
    datapoint: {
      type: "Data Type",
      descriptions: "Descriptions",
      value: "Value",
    },

    rbu: {
      create_title: "Create RBU Edition",
      edition: "Year",
      rbu_edition_name: "Name",
      latest: "Latest",
      base_start: "Base Start",
      base_end: "Base End",
      contract_percentage: "Contract Percentage",
      tcef: "TCEF",
      head_office_overhead_and_profit: "Head office overheads and profit",

      import_from_sor: "Import Items from SoR",
      imported_sor: "Imported SoR",
    },
    rbu_edition: {
      type_NEW_EDITION: "New Edition",
      type_CORRIGENDUM: "Corrigendum",
    },
    rbu_volume: {
      create_title: "Create RBU Volume",
      name: "Name",
      order_no: "Volume No.",
    },
    rbu_section: {
      create_title: "Create RBU Section",
      name: "Name",
      order_no: "Section No.",

      import_template_title: "Import Template",
      template_excel: "Template Excel",
    },
    rbu_item: {
      create_title: "Create RBU Item",
      variations: "Previous/Dummy Item",
      item_dummy_item_no: "Previous/Dummy Item No.",

      previous_item_no: "Previous Item No.",
      dummy_item_no: "Dummy Item No.",
      current_item_no: "Current Item No.",
      item_remark: "Remark",
      rank: "Rank",

      need_manual_update: "Insufficient Census Data",
      manually_selected_rate: "Manually Selected Rate",
      status: "Status",
      last_update_date: "Last Update Date",
    },

    sor_type: {
      SOR: "SoR",
      CORRIGENDUM: "Corrigendum",
      A_SOR: "A-SoR",
    },
    work_order_type: {
      FIX_ONLY: "FIX ONLY",
      SUPPLY_ONLY: "SUPPLY ONLY",
      SUPPLY_AND_FIX_AND_MISC: "SUPPLY & FIX & MISC.",
      TD_AND_CLEAR_WAY: "TD & CLEAR AWAY",
      TD_AND_SET_ASIDE_FOR_REUSE: "TD & SET ASIDE FOR REUSE",
    },
    rate_range: {
      A: "< $20",
      B: "$21 - $50",
      C: "$51 - $200",
      D: "$201 - $500",
      E: "$501 - $3000",
      F: "$3001 - $10000",
      G: "$10001 - $100000",
      H: "> $100000",
    },
    unit: {
      A: "Cubic Meter",
      B: "Square Meter",
      C: "Linear Meter",
      D: "Kilogram",
      E: "Per item / no. / set",
    },
    rules: {
      required: "Required",
      email: "Invalid Email Address",
      phone: "Invalid Telephone Number",
    },
    //
    all: "All",
    logout: "Logout",
    search: "Search",
    create: "Create",
    previous: "Previous",
    back: "Back",
    next: "Next",
    view: "View",
    activate: "Activate",
    deactivate: "Deactivate",
    disable: "Disable",
    enable: "Enable",
    reactivate: "Reactivate",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    created_at: "Created At",
    updated_at: "Updated At",
    lock: "Lock",
    unlock: "Unlock",
    clone: "Clone",
    ok: "OK",
    close: "Close",
    new: "New",
    regenerate: "Regenerate",
    download: "Download",

    error_messages: {
      default: "Something went wrong. Please try again later",
      access_denied: "Access Denied",
      object_not_found: "Object Not Found",

      login_fail: "Incorrect Username / Password",
      otp_invalid: "Incorrect OTP",
      account_disabled: "Account Locked",

      duplicate_username: "Username / Email Address has already been taken",
      invalid_email_address: "Invalid Email Address",

      signup_duplicate_username: "Email has been registered",

      invalid_user_id: "Invalid User",

      invalid_edition_id: "Cannot Find Edition",
      duplicate_edition: "Edition Already Exist",

      invalid_sor_id: "Invalid SoR",
      duplicate_sor_name: "Duplicate SoR Name",
      sor_in_use: "SoRs referrenced by Contracts cannot be deleted",
      sor_volume_action_input_not_finalised:
        "Please review all volumes' ACTION Input before finalising the SoR",
      sor_section_pdf_not_generated:
        'Please review all sections\' content by clicking "PDF" and export PDFs before finalising the SoR',

      invalid_corrigendum_id: "Invalid Corrigendum",
      corrigendum_already_finalised: "Corrigendum Already Finalised",
      corrigendum_pdf_not_generated:
        "Please preview the PDF before finalising Corrigendum",

      invalid_a_sor_id: "Invalid A-SoR",
      unfinished_a_sor: "There is already a un-finalised A-SoR",

      invalid_contract_id: "Invalid Contract",

      invalid_section_id: "Invalid Section",

      invalid_volume_id: "Invalid Volume",
      duplicate_volume_name: "Duplicated Volume Name",
      duplicate_volume_order_no: "Duplicated Volume Order No.",
      volume_already_finalised: "Volume already finalised",

      invalid_sub_section_id: "Cannot Find Sub Section",
      invalid_sub_sub_section_id: "Cannot Find Sub Sub Section",

      action_input_description_too_long:
        "ACTION Input Item Description(s) Too Long. Please check and try again.",

      duplicate_contract_id: "Duplicate Contract ID",

      contract_not_finalised: "Please finalise the contract before proceeding",
      contract_year_already_finalised: "Contract Year Already been Finalised",

      invalid_abbreviation_phrase: "Invalid Abbreviation",
      duplicate_abbreviation_phrase: "Duplicated Abbreviation",

      invalid_work_order_id: "Invalid Works Order",
      invalid_dimbook_id: "Invalid Dimbook",

      duplicate_item_no: "Duplicated Item No.",
      invalid_item_id: "Invalid Item",

      invalid_unicode_escape_replaced: "Invalid Unicode Escape",
      duplicate_unicode_escape_replaced: "Duplicated Unicode Escape",

      invalid_whitelist_id: "Invalid ADFS Whitelist",
      duplicated_whitelist_username: "Duplicated ADFS Whitelist",
    },
  },
  zh: {},
};

const i18n = new VueI18n({
  locale: "en",
  messages,
});

export default i18n;
